
function getTiku(state) {
    if (!state.Tiku) {
        let Tiku_data = localStorage.getItem("Tiku_data")
        if (Tiku_data) {
            state.Tiku = JSON.parse(Tiku_data)
        }
    }
}
const record = {
    namespaced: true,
    state: () => {
        return {
            oneself_list: [],
            Tiku: false,
            new_message: {}
        }
    },
    getters: {
        getType(state) {
            getTiku(state)
            return state.Tiku.rand_question_type
        },
        getRand_question_num(state) {
            getTiku(state)
            return state.Tiku.rand_question_num.split('||')
        },
        getYear(state) {
            getTiku(state)
            return {
                is_year: state.Tiku.max_min_year != "",
                max_year: (state.Tiku.max_year),
                min_year: (state.Tiku.min_year)
            }
        },
        getChapterValue(state) {
            getTiku(state)
            return state.Tiku.question_tab[0].value
        },
        getYearValue(state) {
            getTiku(state)
            let item = state.Tiku.question_tab.find(e => e.key == 'year')

            if (item) {
                return item.value
            } else {
                return "历年真题"
            }
        },
        tikuTitle(state) {
            getTiku(state)
            return state.Tiku.title
        },
        getTiku(state) {
            getTiku(state)
            return state.Tiku
        },
        getNewMessage(state) {
            return state.new_message
        }
    },
    mutations: {
        setNewMessage(state, data) {
            state.new_message = data
        },
        setTiku(state, data) {
            state.Tiku = data
            localStorage.setItem("app_id", data.app_id);
            localStorage.setItem("app_type", data.app_type);
            localStorage.setItem("Tiku_data", JSON.stringify(state.Tiku))
            localStorage.setItem("question_tab", JSON.stringify(state.Tiku.question_tab.filter((e) => {
                return !(e.key == "rand_question" || e.key == "man_machine");
            })))
        }
    },
    actions: {

    }
}
export default record


// WEBPACK FOOTER //
// ./src/store/Tiku.js